import Marquee from "react-fast-marquee";

const ITEMS = [
  "PULIZIA AREE VERDI",
  "PULIZIE INTERNI ED ESTERNI",
  "PROGETTAZIONE AREE VERDI",
  "GESTIONE DIPENDENTI",
  "TRASPORTI SGOMBERI E TRASLOCHI",
];

export default function MarqueeRibbon() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-[#2A5290] bg-neon py-5"
    >
      <Marquee speed={60} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-6 flex items-center gap-12">
            <span className="font-display text-2xl font-bold uppercase tracking-wide text-white sm:text-4xl">
              {item}
            </span>
            <span className="h-2.5 w-2.5 rotate-45 bg-pulse" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
